// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"DealTabs_Tabs__TSSLH","Tab":"DealTabs_Tab__u87Bt","TabLabel":"DealTabs_TabLabel__uNQa4","Active":"DealTabs_Active__74Ra8"};